import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c2040d5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2040d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2040d5')) {
      api.createRecord('4c2040d5', component.options)
    } else {
      api.reload('4c2040d5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c2040d5&scoped=true&", function () {
      api.rerender('4c2040d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersales/sellerList/index.vue"
export default component.exports